import { http, hr_http } from '@/libs/util';
import util from '@/libs/util'
export const { 
    epop_account_query,
    ams_account,
    epop_account_update,
    epop_account_detail,
    epop_monthly_record_add_screenshot,
    epop_monthly_record_import_consume,
    epop_monthly_record_add_unusual_change,
    epop_monthly_record_remove_unusual_change,
    download_attachment,
    epop_monthly_record_export_consume,
    epop_account_mine_query,
    epop_monthly_record_update,
    epop_account_share_delete_config
 } = util.api || {}
 

// 获取消耗计划单
export function getEpopAccountQueryApi(params) {
    return http.get(epop_account_query, params)
}

export function getLoginInfoApi(id) {
    return hr_http.get(`${ams_account}/${id}`)
}

export function getPassWordInfoApi(id, params) {
    return hr_http.get(`/ams/account/${id}/password/`, params)
}

export function postEpopAccountUpdateApi(params) {
    return http.post(epop_account_update, params)
}

export function getEpopAccountDetailApi(params) {
    return http.get(epop_account_detail, params)
}

export function postUploadDataApi(params) {
    return http.post_upload(epop_monthly_record_import_consume, params)
}

// epop_monthly_record_add_screenshot

export function postEpopMonthlyRecordAddScreenShotApi(params) {
    return http.post(epop_monthly_record_add_screenshot, params)
}


export function postEpopMonthlyRecordAddUnusualChangeApi(params) {
    return http.post(epop_monthly_record_add_unusual_change, params)
}

export function postEpopMonthlyRecordRemoveUnusualChangeApi(params) {
    return http.post(epop_monthly_record_remove_unusual_change, params)
}

export function getEpopAccountMineQueryApi(params) {
    return http.get(epop_account_mine_query, params)
}

export function postEpopMonthlyRecordUpdateApi(params) {
    return http.post(epop_monthly_record_update, params)
}

export function postEpopAccountShareDeleteConfigApi(params) {
    return http.post(epop_account_share_delete_config, params)
}
// epop_account_share_delete_config

export function getImageApi(params) {
    return http.get(download_attachment, params)
}
